export { AdressesLocatorComponent } from './adresses-locator/adresses-locator.component'
export { StoresListComponent } from './stores-list/stores-list.component'